import { type FieldType, type IProject } from '@/interfaces'

export class Project implements IProject {
	[key: string]: FieldType
	id: number
	name: string
	description: string
	constructor({ id = 0, name = '', description = '' }: IProject) {
		this.id = id
		this.name = name
		this.description = description
	}
}
